export default __webpack_public_path__ + "static/media/16.1447acbc.jpg";